import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { IconButton } from '@mui/material';
import { orange } from '@mui/material/colors';

export const DropdownFavoriteMasterIcon = ({
  applyFavoriteOptions,
  disabled,
  className,
  allAvailableFavoriteOptionsAreSelected
}) => {
  return (
    <IconButton
      size="small"
      onClick={applyFavoriteOptions}
      sx={{ padding: '2px', color: orange[400] }}
      className={className}
      disabled={disabled}
    >
      {allAvailableFavoriteOptionsAreSelected ? <StarIcon /> : <StarOutlineIcon />}
    </IconButton>
  );
};
